export const unFormatCurrency = (value: string) => {
  if (!value)
    return 0;

  return Number(
    value
      .replace(/[^\d,\-.]/g, '')
      .replace(/,/g, '.')
      .replace(/\.(?=.*\.)/g, '')
  );
};

export const unFormatPercentage = (value: string) => {
  return (
    Number(
      value
        .substring(0, value.length - 2)
        .replace(/[^\d,\-.]/g, '')
        .replace(/,/g, '.')
        .replace(/\.(?=.*\.)/g, '')
    ) / 100
  );
};

export const removeSpecialCharacters = (value: string, options?: { includeSpaces?: boolean }) => {
  if (options?.includeSpaces) {
    return value.replace(/[^a-zA-Z0-9\s]/g, '')
  }

  return value.replace(/[^a-zA-Z0-9]/g, '')
}

export const unFormatCnpj = (value: string) => {
  return value.replace(/\D/g, '')
}

export const unFormatPhone = (value: string) => {
  return value.replace(/\D/g, '')
}

export const unFormatUnit = (value: string, unit: string): number => {
  return Number(value.replace(` ${unit}`, ''))
}

export const unFormatUnknownUnit = (value: string) : number => {
  if (!value)
    return 0;

  return Number(value.split(' ')[0].replace(/\./g, '').replace(',', '.'))
}
